import { forwardRef } from "react";
import { Link, type LinkProps } from "react-router";
import { classNames } from "../../utils/classNames";

export const BreadcrumbLink = forwardRef<HTMLAnchorElement, LinkProps>(
  function BreadcrumbLink({ className, ...props }, ref) {
    return (
      <Link
        ref={ref}
        className={classNames(
          "font-semibold text-2xl/8 text-secondary hover:text-primary transition-colors",
          className,
        )}
        {...props}
      />
    );
  },
);
